// src/utils/user.ts
import { RoleEnum } from "@/enum/role";

export function isUserAdminInGroup(user: any, group: string, role: RoleEnum = RoleEnum.ADMINISTRADOR): boolean {
  if (!user?.user_permission_group) return false;
  const groupObj = user.user_permission_group.find((item: any) => item.group === group);
  return !!groupObj?.role?.includes(role);
}
